import { getAgencyLanguage } from 'lib/languages';

export const getFormattedDate = (dateObj: Date, options: Intl.DateTimeFormatOptions = {}) => {
    return new Intl.DateTimeFormat(
        //@ts-ignore
        getAgencyLanguage(),
        options
    ).format(dateObj);
};

const getFormattedHour = (dateObj: Date) => {
    const hours = ('0' + dateObj.getHours()).slice(-2);
    const minutes = ('0' + dateObj.getMinutes()).slice(-2);

    return `${hours}:${minutes}`;
};

type SmartDateType = 'todayTime' | 'thisYearDate' | 'fullDate';

type SmartDateReturn = {
    type: SmartDateType;
    date: string;
};
export const smartDateFormatter = (value: Date): SmartDateReturn => {
    const updateDate = value;

    if (!updateDate) {
        return {
            type: 'fullDate',
            date: '',
        };
    }

    const date = value;
    const todaysDate = new Date();

    if (
        date.getDate() === todaysDate.getDate() &&
        date.getMonth() === todaysDate.getMonth() &&
        date.getFullYear() === todaysDate.getFullYear()
    ) {
        return {
            type: 'todayTime',
            date: getFormattedHour(updateDate),
        };
    }

    if (date.getFullYear() === todaysDate.getFullYear()) {
        return {
            type: 'thisYearDate',
            date: getFormattedDate(updateDate, { day: 'numeric', month: 'short' }),
        };
    }

    return {
        type: 'fullDate',
        date: getFormattedDate(updateDate, {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
        }),
    };
};
